import React from "react";
import styles from "./styles/PageHeader.module.css";

export default function PageHeader({ title, subHeader, children }) {
  return (
    <div className={styles.cont} slot="fixed">
      <div className={styles.contInner}>
        <div className={styles.headerCont}>
          <div className={styles.header}>{title}</div>
          {subHeader && <div className={styles.bullet}>•</div>}
          <div className={styles.subHeader}>{subHeader}</div>
        </div>
        {children}
      </div>
    </div>
  );
}
